import { render, staticRenderFns } from "./DetailHolidayDialog.vue?vue&type=template&id=12170dac"
import script from "./DetailHolidayDialog.vue?vue&type=script&lang=js"
export * from "./DetailHolidayDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports